import './ecocode-trustpilot-switch-field-config.scss';
import template from './ecocode-trustpilot-switch-field-config.twig';

const {Component, State} = Shopware;
const {object} = Shopware.Utils;

Component.extend('ecocode-trustpilot-switch-field-config', 'sw-switch-field-deprecated', {
    template,
    emits: ['change:value'],
    props: {
        value: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    computed: {
        inputFieldEl() {
            try {
                return document.getElementById(this.formFieldName);
            } catch (e) {
                console.info('unable to get input field element')
            }
        },
        wrapperEl() {
            try {
                if (!this.inputFieldEl) {
                    return null  // can happen on component rerender state
                }
                // get component wrapper element
                return this.inputFieldEl
                    .parentElement
                    .parentElement
                    .parentElement
                    .parentElement
            } catch (e) {
                console.info('unable to get wrapper element')
            }
        },
        displayState() {
            return State.getters[this.$attrs.watchField];
        }
    },
    watch: {
        value(newValue) {
            this.$emit('change:value', object.cloneDeep(newValue));
            State.commit(this.$attrs.state, newValue);
        },
        displayState(displayState, oldDisplayState) {
            this.checkWatcherField(displayState);
        }
    },
    methods: {
        checkWatcherField(fieldState) {
            if (this.$attrs.hasOwnProperty('watchField')) {
                if (!this.wrapperEl) {
                    return  // can happen on component rerender state
                }
                this.wrapperEl.style.display = fieldState ? 'inherit' : 'none';
            }
        },
    },
    created() {
        State.commit(this.$attrs.state, object.cloneDeep(this.value));
    },
    mounted() {
        // we need timer to allow render input fields otherwise we will get error
        setTimeout(() => {
            this.checkWatcherField(this.displayState);
        }, 0)
    },
});
